import { Injector } from '@angular/core';
import { AbstractControl, FormControl, NgControl } from '@angular/forms';
import { DestroyableComponent } from 'src/app/common/destroyable.component';

export class CustomFormControl extends DestroyableComponent {
  public isRequired: boolean;
  public errors: any;
  public control: AbstractControl;
  public isDisabled: boolean = false;

  constructor(private injector: Injector) {
    super();
  }

  protected initBase() {
    this.checkIsRequired();
    this.control = this.injector.get(NgControl).control;
  }

  protected checkIsRequired(): void {
    const ngControl = this.injector.get(NgControl);
    if (ngControl) {
      this.isRequired = this.isControlRequired(ngControl.control);
    }
  }

  protected isControlRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) return false;

    // Extract validator functions
    const validatorFn = control.validator({} as AbstractControl);

    return validatorFn?.required;
  }

  protected applyDisabledState(disabled: boolean): void {
    this.isDisabled = disabled;
    if (disabled) {
      this.isRequired = false;
    } else {
      this.checkIsRequired();
    }
  }

  validate(control: FormControl): { [key: string]: any } | null {
    const validatorFn = control.validator;
    if (!validatorFn) return null;
    this.errors = validatorFn(new FormControl(control.value));
    return this.errors;
  }
}
